import { createAction, handleActions } from 'redux-actions'
import update from 'immutability-helper'

const UPDATE_STATE = 'COMBINE_CROWD_UPDATE_STATE'

const initialState = {
  conditions: [] as any[]
}


export type CombineCrowdState = typeof initialState

function setState<T> (state: CombineCrowdState, field: string, value: T): CombineCrowdState {
  if (!state.hasOwnProperty(field)) {
    console.error(`modules-combine-reducer[ERROR]: can't find ${field} property in CombineCrowdState`)
  }
  
  return update(state, { [field]: { $set: value } })
}


export default handleActions<CombineCrowdState>({
  [UPDATE_STATE] (state,  { payload }) {
    
      let s = state
      for (let key in payload) 
        s = setState(s, key, payload[key])
      
      return s
  },
  
}, initialState)

export const updateStateAction = createAction(UPDATE_STATE)
export const updateState = params => dispatch => {
  dispatch(updateStateAction(params))
}
